// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"7ed6f216","74":"18ad357b","200":"18ad357b","295":"bdf1a855","392":"7ed6f216","786":"18ad357b"}[chunkId] + ".chunk.css";
};